module.exports = __webpack_public_path__ + "img/production.e537ad57.svg";